const SLIDER_STYLES = {
  'input[type=range]': {
    height: '42px',
    '-webkit-appearance': 'none',
    margin: '10px 0',
    width: '100%',
    bg: '#E5E5E5',
  },
  'input[type=range]:focus': {
    outline: 'none',
  },
  'input[type=range]::-webkit-slider-runnable-track': {
    width: '100%',
    height: '5px',
    cursor: 'pointer',
    animate: '0.2s',
    boxShadow: '1px 1px 1px #000000',
    background: '#000000',
    borderRadius: '1px',
    border: '0px solid #010101',
  },
  'input[type=range]::-webkit-slider-thumb': {
    boxShadow: '1px 1px 1px #000031',
    border: '1px solid #00001E',
    height: '34px',
    width: '34px',
    borderRadius: '20px',
    background: '#FFFFFF',
    cursor: 'pointer',
    '-webkit-appearance': 'none',
    marginTop: '-12px',
  },
  'input[type=range]:focus::-webkit-slider-runnable-track': {
    background: '#000000',
  },
  'input[type=range]::-moz-range-track': {
    width: '100%',
    height: '11px',
    cursor: 'pointer',
    animate: '0.2s',
    boxShadow: '1px 1px 1px #000000',
    background: '#000000',
    borderRadius: '1px',
    border: '0px solid #010101',
  },
  'input[type=range]::-moz-range-thumb': {
    boxShadow: '1px 1px 1px #000031',
    border: '1px solid #00001E',
    height: '34px',
    width: '34px',
    borderRadius: '20px',
    background: '#FFFFFF',
    cursor: 'pointer',
  },
  'input[type=range]::-ms-track': {
    width: '100%',
    height: '11px',
    cursor: 'pointer',
    animate: '0.2s',
    background: 'transparent',
    borderColor: 'transparent',
    color: 'transparent',
  },
  'input[type=range]::-ms-fill-lower': {
    background: '#000000',
    border: '0px solid #010101',
    borderRadius: '2px',
    boxShadow: '1px 1px 1px #000000',
  },
  'input[type=range]::-ms-fill-upper': {
    background: '#000000',
    border: '0px solid #010101',
    borderRadius: '2px',
    boxShadow: '1px 1px 1px #000000',
  },
  'input[type=range]::-ms-thumb': {
    marginTop: '1px',
    boxShadow: '1px 1px 1px #000031',
    border: '1px solid #00001E',
    height: '34px',
    width: '34px',
    borderRadius: '20px',
    background: '#FFFFFF',
    cursor: 'pointer',
    content: '"99"',
  },
  'input[type=range]:focus::-ms-fill-lowe': {
    background: '#000000',
  },
  'input[type=range]:focus::-ms-fill-upper': {
    background: '#000000',
  },
}

export default SLIDER_STYLES
